import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DemoModeService } from '../../services/demo-mode.service';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-demo-banner',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './demo-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './demo-banner.component.scss'
})
export class DemoBannerComponent {
  protected readonly demoMode = inject(DemoModeService);
  // Environment-sourced funnel URL — a hardcoded prod URL here sent dev-demo visitors to the
  // production funnel.
  protected readonly signUpUrl = `${environment.marketingBaseUrl}/start?utm_source=demo&utm_medium=banner`;
}
